import { Link } from "react-router-dom";
import { Youtube, ArrowUpRight } from "lucide-react";
import { MODULES, YOUTUBE_URL } from "../data/modules";
import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer className="kraft" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
      <div className="grid lg:grid-cols-[1.3fr_1fr] gap-14">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[#E8D9BE]">Notes written by</p>
          <h2 className="font-display text-6xl sm:text-8xl text-[#FFF4DC] leading-[0.9] mt-3" data-testid="footer-channel-name">Himanshu Soni</h2>
          <p className="font-hand text-xl text-[#FFE45C] mt-4 max-w-md">Har module ka practical video YouTube pe. Notes yahan, samjhaana wahan.</p>
          <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer" className="footer-yt" data-testid="footer-youtube-link">
            <Youtube size={22} /> Himanshu Soni on YouTube <ArrowUpRight size={18} />
          </a>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[#E8D9BE] mb-4">All 10 modules</p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2">
            {MODULES.map((m) => (
              <li key={m.id}>
                <Link to={`/module/${m.slug}`} className="footer-link" data-testid={`footer-module-link-${m.id}`}>
                  <span className="font-mono text-xs text-[#FFE45C] mr-2">{String(m.id).padStart(2, "0")}</span>{m.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mt-16 pt-6 border-t border-[#E8D9BE]/20 flex flex-col sm:flex-row gap-3 justify-between text-sm text-[#E8D9BE]">
        <span className="flex items-center gap-2"><LogoMark size={22} /> ROAS Diary · Performance Marketing notes by Himanshu Soni</span>
        <span>© 2026 Himanshu Soni</span>
      </div>
    </div>
  </footer>
);
